/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bdk/v2/services/library.proto
 * OpenAPI spec version: version not set
 */

export type Bdkv2OAuthFlow =
  (typeof Bdkv2OAuthFlow)[keyof typeof Bdkv2OAuthFlow];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Bdkv2OAuthFlow = {
  OAuthFlowAuthorizationCode: 'OAuthFlowAuthorizationCode',
  OAuthFlowClientCredentials: 'OAuthFlowClientCredentials',
} as const;
